import { useWorkspace } from '@/features/workspaces/hooks';
import { Audience } from '@/models/audiences';
import { RootState } from '@/reducers';
import { useGetWorkspaceUsageSummaryQuery } from '@/services/endpoints/workspaces';
import { Form, Formik, FormikProps } from 'formik';
import { FC, RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AudienceSyncConfig } from './AudienceSyncConfig';
import { validateSchedule } from './validation';

export type AudienceSyncFormModel = Pick<Audience, 'scheduleType' | 'scheduleConfiguration'>;

type AudienceSyncContainerProps = {
  formRef: RefObject<FormikProps<AudienceSyncFormModel>>;
};

export const AudienceSyncContainer: FC<AudienceSyncContainerProps> = ({ formRef }) => {
  const workspace = useWorkspace();
  const audience = useSelector((state: RootState) => state.audienceEdit.audience);
  const { t } = useTranslation('audience_edit');

  const { data: workspaceUsageSummary } = useGetWorkspaceUsageSummaryQuery({ workspaceId: workspace.id });

  const onSubmit = () => {
    console.log('submit sync');
  };

  return (
    <div className='flex w-full gap-8 text-left'>
      <div className='flex w-[280px] shrink-0 flex-col gap-2'>
        <h3 className='mb-1 text-base font-bold'>{t('sync')}</h3>
        <p className='mb-5 text-base text-gray-600'>{t('decideWhenAndHowMuchYourAudienceNeedsToUpdateBasedOnYourSpecificNeeds')}</p>
      </div>
      <div className='min-w-0 flex-1'>
        <Formik
          innerRef={formRef}
          initialValues={{
            scheduleType: audience?.scheduleType || 'MANUAL',
            scheduleConfiguration: audience?.scheduleConfiguration || {},
          }}
          validate={(values) => validateSchedule(values, t)}
          onSubmit={onSubmit}
        >
          {({ values, handleChange, setFieldValue }) => (
            <Form>
              <AudienceSyncConfig
                isFetchingSummary={!workspaceUsageSummary}
                realTimeAudienceLeft={workspaceUsageSummary?.realTimeAudienceLeft || 0}
                scheduleType={values.scheduleType}
                scheduleConfiguration={values.scheduleConfiguration}
                handleChange={handleChange}
                setFieldValue={setFieldValue}
              />

              {/*<AudienceSyncAdvancedOptions
                scheduleType={values.scheduleType}
                scheduleConfiguration={values.scheduleConfiguration}
                setFieldValue={setFieldValue}
              />*/}
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
